<template>
  <div>
    <v-row>
      <v-col cols="12" md="6">
        <input
          type="text"
          class="mip"
          v-model="paymentDescription"
          :rules="nameRules"
          placeholder="Payment Description"
          required
          list="categories"
        />
        <datalist id="categories">
          <option
            v-for="(category,i) in categories"
            :value="category.id+'-'+category.name"
            :key="i+Math.random()+Math.random()"
          >{{category.name}}</option>
        </datalist>
      </v-col>
      <v-col cols="12" md="6">
        <input
          type="text"
          class="mip"
          v-model="amount"
          :rules="nameRules"
          placeholder="Amount"
          required
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </div>
</template>

<script>
import axios from "../../plugins/axios";

export default {
  created() {
    axios
      .getData("/auth/get-all-expenses-categories", this.getAccessToken)
      .then(categories => {
        this.categories = categories;
      });
  },
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    }
  },
  data() {
    return {
      nameRules: [v => !!v || "Field is required"],
      paymentDescription: null,
      amount: null,
      categories: []
    };
  }
};
</script>

<style>
</style>